module.exports = __webpack_public_path__ + "img/34.fc02cbf3.jpg";